export default "__VITE_ASSET__2bd694b4__"